var baseUrl = 'https://wv.valthea.com/20204';

var shopDomain="https://"+Shopify.shop;

var selectRingSize = 0;

function readWooSpecData() {
    var sessionData = {};
    var localData = {};
    try { sessionData = JSON.parse(sessionStorage.getItem("wooSpecData") || "{}"); } catch (e) {}
    try { localData = JSON.parse(localStorage.getItem("wooSpecData") || "{}"); } catch (e) {}
    var mergedData = Object.assign({}, localData, sessionData);
    mergedData.ring = localData.ring || sessionData.ring;
    mergedData.diamond = sessionData.diamond || localData.diamond;
    return mergedData;
}

function isShapeSpec(specName) {
    var name = (specName || "").trim().toUpperCase();
    return name === "SHAPE" || name === "DIAMOND SHAPE" || name === "DIAMOND TYPE";
}

function ringDisplayTitle(ring) {
    if (!ring) return "";
    return ring.title || ring.name || (ring.handle ? ring.handle.replace(/-/g, " ") : "");
}

function safeImageHtml(src, className) {
    if (!src) return "";
    return `<img alt="" ${className ? `class="${className}"` : ""} src="${src}" onerror="this.remove()">`;
}

function fetchDiamondSize(diamondShape) {
    let url = `${baseUrl}/store/product//diamondsize/list?shopDomain=${shopDomain}`;
    if(diamondShape){
        url+=`&shape=${diamondShape}`;
    }
    try {

        return (async () => {
            const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })(); // 立即执行 async 函数
    } catch (error) {
        console.error('POST request error:', error);
        throw error;
    }

}
wv$(function () {
    var wooSpecData = readWooSpecData();
    if(!wooSpecData || Object.keys(wooSpecData).length === 0){
        // 否则跳转钻石列表页
        window.location.href='/collections/diamonds';
        return;
    }
    if(!wooSpecData || !wooSpecData.ring){
        window.location.href='/collections/rings';
        return;
    }
    var isNoDiamond = wooSpecData.ring.noDiamond === true;
    if(!wooSpecData.diamond && !isNoDiamond){
        window.location.href='/collections/diamonds?flow=modify-diamond';
        return;
    }
    if(isNoDiamond){
        wv$(".diamond-only").remove();
        wv$('[data-testid="asset-video"]').remove();
    }
    if(wooSpecData.ring){
        var initialTitle = ringDisplayTitle(wooSpecData.ring);
        if(initialTitle){
            wv$(".productTitle").html(initialTitle);
            wv$(".details-title").html(initialTitle+"  Details");
        }
    }
    if(wooSpecData.ring && wooSpecData.ring.featuredImage){

        //第一张图，戒托
        var ringImage = `<img draggable="false" alt=""
							width="344" height="344" decoding="async" data-nimg="1"
							src="${wooSpecData.ring.featuredImage}"
							onerror="this.remove()"
							style="color: transparent;">`;
        wv$("#imageZoom").html(ringImage);
    }
    var diamondShape = null;
    if(wooSpecData.diamond){
        //第二张图，钻石图片或者视频
        var diamondMedia= '';
        if(wooSpecData.diamond.video){
            diamondMedia = `<video preload="auto" autoplay="" loop="" title=""
						poster="${wooSpecData.diamond.featuredImage}"
						playsinline="" webkit-playsinline="" x5-playsinline="" style="width: 100%; height: 100%;">
						<source src="${wooSpecData.diamond.video}" type="video/mp4">
						</video>`;
        }else if(wooSpecData.diamond.featuredImage){
            diamondMedia = safeImageHtml(wooSpecData.diamond.featuredImage);
        }


        wv$(".diamondMedia").html(diamondMedia);
        if(wooSpecData.diamond.shape){
            diamondShape =wooSpecData.diamond.shape;
        }

    }

    // diamond-to-setting 页面不展示手部效果下拉图。
    wv$(".ctRlOc").remove();


    var li =[];
    if(wooSpecData.diamond){
        //钻石价格
        var diamondPrice =Intl.NumberFormat("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(wooSpecData.diamond.price / 100);
        wv$(".diamond‌_price").html(`$${diamondPrice}`);

        //变体
        li.push(`<li>
				<span class="label">
					Shape:
				</span>
				<span class="value">
					${wooSpecData.diamond.shape}
				</span>
				<span class="toggle">
					<button onclick="window.location.href='/collections/diamonds?flow=modify-diamond'">
						Modify
					</button>
				</span>
			</li>`);
        li.push(`<li>
				<span class="label">
					Centerstone:
				</span>
				<span class="value">
					${wooSpecData.diamond.carat}ct, ${wooSpecData.diamond.color}, ${wooSpecData.diamond.clarity}, ${wooSpecData.diamond.cut}
				</span>
				<span class="toggle">
					<button  onclick="window.location.href='/collections/diamonds?flow=modify-diamond'">
						Modify
					</button>
				</span>
			</li>`);
    }
    if(wooSpecData.ring){
        //戒托 商品标题、详情
        var productTitle = ringDisplayTitle(wooSpecData.ring);
        if(productTitle){
            wv$(".details-title").html(productTitle+"  Details");
            wv$(".productTitle").html(productTitle);
        }
        fetch(`${window.Shopify.routes.root}products/${wooSpecData.ring.handle}.js`)
            .then(response => response.json()).then(product => {
            if(product.description){
                wv$(".description__product-details").html(product.description);
            }

    }).catch(function(error){
            console.warn("Failed to load ring product details.", error);
        });
        //戒托价格
        var ringPrice =Intl.NumberFormat("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(wooSpecData.ring.price / 100);
        wv$(".ringsetting‌_price").html(`$${ringPrice}`);

        //变体
        if(wooSpecData.ring.specSku){
            for(var i=0;i<wooSpecData.ring.specSku.length;i++){
                var item = wooSpecData.ring.specSku[i];
                if(isShapeSpec(item.specName)){
                    continue;
                }
                li.push(`<li>
                    <span class="label">
                        ${item.specName}:
                    </span>
                    <span class="value">
                        ${item.specValue}
                    </span>
                    <span class="toggle">
                        <button  onclick="window.location.href='/collections/rings?flow=modify-ring'">
                            Modify
                        </button>
                    </span>
                </li>`);
            }
        }

            if(wooSpecData.ring.ringSize){
                var items = wooSpecData.ring.ringSize.split(",");
                if(selectRingSize==0){
                    selectRingSize = items[0];
                }
                wv$(".select-ring-size").html(selectRingSize);
                var buttons = [];
                for(var i=0;i<items.length;i++){
                    var item = items[i];
                    if(items.length>20){
                        if(item.indexOf(".")!=-1 || buttons.length>5){
                            continue
                        }

                    }else if(items.length>10){
                        if(buttons.length>5){
                            continue
                        }
                    }

                    buttons.push(`<button class="sizes_button jEkioG hKIIFy option-item ${item==selectRingSize?'selected':''}">
                        ${item}
                        </button>`);

                }
                if(items.length>10){
                    buttons.push(`<div class="sc-99648e42-0 igzorI show-more-sizes-button button-style--underline color-theme--teal text-size--normal font-weight--medium">
					<button type="button" class="show_more_sizes">
						Show more sizes
					</button>
				</div>`);
                }

                wv$(".ringSize").html(buttons.join(""));
            }


    }
    wv$(".list-unstyled").html(li.join(""));


    wv$(".show_more_sizes").on("click",function () {
        var items = wooSpecData.ring.ringSize.split(",");
        var buttons = [];
        for(var i=0;i<items.length;i++){
            var item = items[i];

            buttons.push(`<button class="sizes_button jEkioG hKIIFy option-item ${item==selectRingSize?'selected':''}">
                        ${item}
                        </button>`);

        }
        wv$(".ringSize").html(buttons.join(""));
    });

    wv$(document).on('click', '.sizes_button', function() {
        wv$(".sizes_button").removeClass("selected");
        wv$(this).addClass("selected");
        selectRingSize = wv$(this).text().trim();
        wv$(".select-ring-size").html(selectRingSize);
    });


});


wv$("#cars").on("change",function () {});

wv$(".product-buy-buttons--primary").on("click",function () {
    //window.productData
   //获取商品 id、变体价格、变体id、变体图片（如果没有直接获取商品图片）

    var _this = wv$(this);
    var wooSpecData = readWooSpecData();
    if(!wooSpecData.ring){
        window.location.href='/collections/rings';
        return;
    }

    var sid = generateShortId();

    wv$(this).attr("aria-busy","true");
    var ring = wooSpecData.ring;
    var ringProperties= {
        "Alias name": ring.alias,
        "Ring size":selectRingSize,
        "SID":sid
    };
    var finishAddToCart = function () {
        window.sessionStorage.removeItem("wooSpecData");
        window.localStorage.removeItem("wooSpecData");
        setTimeout(function () {
            window.location.href='/cart';
        },3000);
    };

    if(ring.noDiamond === true){
        addToCart(ring.variantId,1,ringProperties,finishAddToCart,function (res) {
            errorMessage(_this,"/collections/rings",res.responseJSON.message);
        });
        return;
    }

    if(!wooSpecData.diamond){
        window.location.href='/collections/diamonds?flow=modify-diamond';
        return;
    }

    //添加戒托和钻石到购物车
    var productUrl  =`${window.Shopify.routes.root}products/${wooSpecData.diamond.handle}.js`;
    fetch(productUrl).then(response => response.json())
        .then(product => {
            var variants = product.variants;
            if(!variants[0].available){
                return
            }

            addToCart(ring.variantId,1,ringProperties,function () {

                var diamond = wooSpecData.diamond;
                var diamondProperties= {
                    "Cut": diamond.cut,
                    "Clarity":diamond.clarity,
                    "Color":diamond.color,
                    "Shape":diamond.shape,
                    "SID":sid
                };
                addToCart(diamond.variantId,1,diamondProperties,function () {
                    finishAddToCart();
                },function (res) {
                    errorMessage(_this,"/collections/diamonds",res.responseJSON.message);
                })

            },function (res) {
                errorMessage(_this,"/collections/rings",res.responseJSON.message);
            })


});



});
function errorMessage(_this,url,text) {
    _this.attr("aria-busy","false");

    var html=`<p class="addtocart-error" style="color:#ef3434;margin-top: 1rem;">${text}
            <a style="text-decoration: underline;color:var(--color-teal)" href="${url}">Reselect‌</a></p>`;
    _this.after(html);
}
function  addToCart(variantId,quantity,properties,callback,errorCallback){

    var formData = {
        'items': [{
            'id': variantId,
            'quantity': quantity,
            'properties':properties
        }]
    };
    wv$.ajax({
        url: window.Shopify.routes.root + 'cart/add.js',
        dataType: "json",
        data: JSON.stringify(formData),
        type: "POST",
        contentType: "application/json;charset=UTF-8",
        async: true,
        beforeSend: function () {},
        success: function (res) {
            callback();
        },error: function (res) {
           if(errorCallback){
               errorCallback(res);
           }
        },complete: function(res) {}

    });
}

function generateShortId() {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let id = '';
    for (let i = 0; i < 8; i++) {
        // 随机取字符（使用crypto提高随机性）
     const randomIndex = Math.floor(window.crypto.getRandomValues(new Uint32Array(1))[0] / (0xFFFFFFFF + 1) * chars.length); id += chars[randomIndex];
    }
    return id;
}
